import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { SafeHtml, DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { LmsContentEditorComponent } from "app/pages/full-pages/admin/lms-layout/lms-content-editor/lms-content-editor.component";
import { ApiService } from "app/shared/services/api.service";
import { environment } from "environments/environment";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-lms-content",
  templateUrl: "./lms-content.component.html",
  styleUrls: ["./lms-content.component.scss"],
})
export class LmsContentComponent implements OnInit {
  selectedItem = "All";
  searchValue: "";
  s3MediaUrl = environment?.apiUrls?.s3MediaUrl;
  currentDate: Date = new Date();
  @Input() courseId: any;
  @Input() topicId: any;
  @Input() isReadMode: any;
  @Input() activeCourseName: any;
  @Input() activeSectionName: any;
  @Input() activeChapterName: any;
  @Input() activeTopicName: any;
  apps: any[] = [];
  @Input() topics: any[] = [];
  isLoading: boolean = false;
  @Input() appsByTopic: any[] = [];
  @Output() refreshData = new EventEmitter<any>();
  isAppBtns: boolean = false;
  appType: any;
  @ViewChild("modalRef") modal: LmsContentEditorComponent;
  sanitizedUrl: SafeHtml;
  sanitizedContent: SafeHtml;
  selectedApp: any;
  user: any;
  assignment_model = {
    student_id: "",
    course_id: "",
    topic_id: "",
    app_id: "",
    title: "",
    notes: "",
    admin_notes: "",
  };
  isAddFormShow: boolean = true;
  isSubmitted: any;
  selectedAppContent: number = 0;
  resources_list = [];
  selected_resources = [];
  app_tag_cat_id = "648956a313fb47cb1a45e844"; //'648058e70c699e0bd984ec30'
  app_tags_list = [];
  selected_app_tag = "64884b753ec230f996841247";
  lms_model = {
    content_scripts: "",
    teachers_notes: "",
    description: "",
  };
  modalFor;
  file: File;
  app_id;
  formData = new FormData();
  empType = [];
  toggleClass = "ft-maximize-2";

  @Input() currentTopicIndex: number = 0; // Current topic index
  @Output() previousTopic = new EventEmitter<void>(); // For 'Previous' button
  @Output() nextTopic = new EventEmitter<void>(); // For 'Next' button
  constructor(
    private router: Router,
    private toast: ToastrService,
    private _sanitizer: DomSanitizer,
    private apiService: ApiService,
    private modalService: NgbModal,
    private elementRef: ElementRef
  ) {
    this.user = JSON.parse(localStorage.getItem("user"));
    if (this.user.roles !== "admin" && this.user.roles !== "student") {
      this.empType = this.user.employeetype.map((item) => item.displayname);
    }
  }
  get currentTopic() {
    return this.topics[this.currentTopicIndex];
  }

  // Emit event for 'Previous' button
  onPrevious() {
      this.previousTopic.emit();
  }

  // Emit event for 'Next' button
  onNext() {
      this.nextTopic.emit();
  }
  ngOnInit(): void {
    this.appTags();
    this.getResourceList();
  }
  ngOnChanges() {
    this.isLoading = true;
    this.apps = [...this.appsByTopic];
    this.selectedAppContent =0
    this.isAddFormShow = this.apps.length > 0 ? false : true;
    // this.sanitizedContent = this.apps[0]?.content?this.getSanitizedHtml(this.apps[0]?.content):this.apps[0]?.content;
    if (this.user.id && this.topicId && this.apps[0]?._id) {
      this.checkAssignmentIsSubmit(
        this.user.id,
        this.topicId,
        this.apps[0]?._id
      );
    }
    setTimeout(() => {
      this.apps.forEach((app) => {
        this.sanitizedContent = app?.content
          ? this.getSanitizedHtml(app?.content)
          : app?.content;
        this.isLoading = false;
      });
      this.isLoading = false;
    }, 3000);
  }
  closeModel(): void {
    this.refreshData.emit();
  }
  getSanitizedHtml(data: any): SafeHtml {
    const formattedText = data.replace(/<[^>]+>/g, "");
    const formattedTextWithoutSpaces = formattedText.replace(/&nbsp;/g, " ");
    return this._sanitizer.bypassSecurityTrustHtml(formattedTextWithoutSpaces);
  }

  formatHtml(videoURL) {
    return JSON.parse(videoURL);
  }

  items: string[] = ["Option 1", "Option 2", "Option 3"];
  searchTerm: string;

  get filteredItems$(): string[] {
    return this.searchTerm ? this.filterItems(this.searchTerm) : [];
  }

  filterItems(value: string): string[] {
    return this.topics.filter((item) =>
      item.name.toLowerCase().includes(value.toLowerCase())
    );
  }

  selectItem(item: string): void {
    this.searchTerm = item;
  }

  openModalForAssignment(content, userId, appId, courseId, topicId) {
    this.assignment_model.student_id = userId;
    this.assignment_model.app_id = appId;
    this.assignment_model.course_id = courseId;
    this.assignment_model.topic_id = topicId;
    const options: NgbModalOptions = {
      size: "md", // set the size of the modal
      backdrop: "static", // set whether clicking outside the modal closes it
      centered: true, // set whether the modal is centered vertically
    };

    const modalRef = this.modalService.open(content, options);

    modalRef.result.then((result) => {});
  }
  assignmentSubmit() {
    this.apiService
      .createAssignment(this.assignment_model)
      .subscribe((res: any) => {
        if (res?.statusCode === 200) {
          this.toast.success("Assignment submit successfull!");
          this.modalService.dismissAll();
          this.checkAssignmentIsSubmit(
            this.user.id,
            this.topicId,
            this.apps[0]?._id
          );
        } else this.toast.error(res?.error);
      });
  }
  checkAssignmentIsSubmit(userId, topicId, appId) {
    this.apiService
      .checkAssignmentSubmitByStudent(userId, topicId, appId)
      .subscribe((res: any) => {
        this.isSubmitted = res?.data;
      });
  }
  showContent(index: number): void {
    this.selectedAppContent = index;
  }
  appTags() {
    this.apiService
      .getTagByTagCatgoryId(this.app_tag_cat_id)
      .subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.app_tags_list = res?.data;
        }
      });
  }
  getAppTagId(event: any) {
    this.selected_app_tag;
  }
  getResourceList() {
    this.apiService.getResourceList(1, 100).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.resources_list = res?.items;
      }
    });
  }
  getResourceId(event: any) {
    this.selected_resources;
  }

  getAppsByTopic() {
    let pageSize = 25;
    let pageNo = 1;

    this.apiService
      .getAppsByTopic(this.topicId, pageSize, pageNo)
      .subscribe((res: any) => {
        if (res.isSuccess) {
          this.appsByTopic = res.data.map((item) => item.app);
        }
      });
  }
  toggleView() {
    this.isAddFormShow = !this.isAddFormShow;
  }
  // ToggleClass() {
  //   if (this.toggleClass === "ft-maximize-2") {
  //     this.toggleClass = "ft-minimize-2";
  //     const target =
  //   document.getElementById('target');
  //   target.addEventListener('click', (e:any) => {
  //     e.currentTarget?.requestFullscreen();
  //   });
  //   } else {
  //     this.toggleClass = "ft-maximize-2";
  //     if (document.exitFullscreen) {
  //           document.exitFullscreen();
  //           }
  //   }

  // }
  // ToggleClass() {
  //   const target = document.getElementById('target');

  //   if (this.toggleClass === "ft-maximize-2") {
  //     this.toggleClass = "ft-minimize-2";

  //     target.addEventListener('click', (e) => {
  //       if (target.requestFullscreen) {
  //         target.requestFullscreen();
  //       } else if (target.requestFullscreen) { /* Firefox */
  //         target.requestFullscreen();
  //       } else if (target.requestFullscreen) { /* Chrome, Safari & Opera */
  //         target.requestFullscreen();
  //       } else if (target.requestFullscreen) { /* IE/Edge */
  //         target.requestFullscreen();
  //       }
  //     });
  //   } else {
  //     this.toggleClass = "ft-maximize-2";

  //     if (document.exitFullscreen) {
  //       document.exitFullscreen();
  //     }
  //     // else if (document.mozCancelFullScreen) { /* Firefox */
  //     //   document.mozCancelFullScreen();
  //     // }
  //     else if (document.exitFullscreen) { /* Chrome, Safari & Opera */
  //       document.exitFullscreen();
  //     } else if (document.exitFullscreen) { /* IE/Edge */
  //       document.exitFullscreen();
  //     }
  //   }
  // }

  // ToggleClass() {
  //   const target = document.getElementById('target');

  //   if (this.toggleClass === "ft-maximize-2") {
  //     this.toggleClass = "ft-minimize-2";

  //     target.addEventListener('click', (e) => {
  //       // Use type assertions to inform TypeScript that the properties exist
  //       const element = target as any;
  //       const doc = document as any;

  //       if (element.webkitRequestFullscreen) {
  //         element.webkitRequestFullscreen(); // for iOS
  //       } else if (element.requestFullscreen) {
  //         element.requestFullscreen();
  //       }

  //       // Add an event listener for fullscreen change on iOS
  //       doc.addEventListener('webkitfullscreenchange', (event) => {
  //         if (!doc.webkitIsFullScreen) {
  //           this.toggleClass = "ft-maximize-2";
  //         }
  //       });
  //     });
  //   } else {
  //     this.toggleClass = "ft-maximize-2";

  //     const doc = document as any;

  //     if (doc.exitFullscreen) {
  //       doc.exitFullscreen();
  //     } else if (doc.webkitExitFullscreen) {
  //       doc.webkitExitFullscreen(); // for iOS
  //     }
  //   }
  // }
  ToggleClass() {
    // const target = document.getElementById("target");

    // if (this.toggleClass === "ft-maximize-2") {
    //   this.toggleClass = "ft-minimize-2";

    //   target.addEventListener('click', () => {
    //     const element = target as any;

    //     if (element.requestFullscreen) {
    //       element.requestFullscreen();
    //     } else if (element.webkitRequestFullscreen) {
    //       element.webkitRequestFullscreen(); // for iOS
    //     }
    //   });

    //   document.addEventListener('fullscreenchange', () => {
    //     if (!document.fullscreenElement) {
    //       this.toggleClass = "ft-maximize-2";
    //     }
    //   });
    // } else {
    //   this.toggleClass = "ft-maximize-2";

    //   const doc = document as any;

    //   if (doc.exitFullscreen) {
    //     doc.exitFullscreen();
    //   } else if (doc.webkitExitFullscreen) {
    //     // Check if the property exists before using it
    //     doc.webkitExitFullscreen(); // for iOS
    //   }
    // }

    // ===================
    // const target = this.elementRef.nativeElement.querySelector('#target');

    // if (this.toggleClass === "ft-maximize-2") {
    //   this.toggleClass = "ft-minimize-2";

    //   target.addEventListener('click', () => {
    //     const element = target as any;

    //     if (element.requestFullscreen) {
    //       element.requestFullscreen();
    //     } else if (element.webkitRequestFullscreen) {
    //       element.webkitRequestFullscreen(); // for iOS
    //     }
    //   });

    //   document.addEventListener('fullscreenchange', () => {
    //     if (!document.fullscreenElement) {
    //       this.toggleClass = "ft-maximize-2";
    //     }
    //   });
    // } else {
    //   this.toggleClass = "ft-maximize-2";

    //   const doc = document as any;

    //   if (doc.exitFullscreen) {
    //     doc.exitFullscreen();
    //   } else if (doc.webkitExitFullscreen) {
    //     doc.webkitExitFullscreen(); // for iOS
    //   }
    // }

    var targetElement = document.getElementById("target");
    if (this.toggleClass === "ft-maximize-2") {
      this.toggleClass = "ft-minimize-2";
      if (targetElement) {
        if (targetElement.requestFullscreen) {
          targetElement.requestFullscreen();
        } else if (targetElement["mozRequestFullScreen"]) {
          // Firefox
          targetElement["mozRequestFullScreen"]();
        } else if (targetElement["webkitRequestFullscreen"]) {
          // Chrome, Safari and Opera
          targetElement["webkitRequestFullscreen"]();
        } else if (targetElement["webkitRequestFullScreen"]) {
          // Chrome, Safari and Opera
          targetElement["webkitRequestFullScreen"]();
        } else if (targetElement["msRequestFullscreen"]) {
          // IE/Edge
          targetElement["msRequestFullscreen"]();
        }
      }
    } else {
      this.toggleClass = "ft-maximize-2";
      if (targetElement) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (targetElement["mozCancelFullScreen"]) {
          // Firefox
          targetElement["mozCancelFullScreen"]();
        } else if (targetElement["webkitExitFullscreen"]) {
          // Chrome, Safari and Opera
          targetElement["webkitExitFullscreen"]();
        } else if (targetElement["webkitCancelFullScreen"]) {
          // Chrome, Safari and Opera
          targetElement["webkitCancelFullScreen"]();
        } else if (targetElement["msExitFullscreen"]) {
          // IE/Edge
          targetElement["msExitFullscreen"]();
        }
      }
    }
  }

  backTo() {
    if (this.toggleClass === "ft-minimize-2") {
      this.toggleClass = "  ft-maximize-2";
    } else {
      this.toggleClass = "ft-minimize-2";
    }
    const target = document.getElementById("target1");
    target.addEventListener("click", (e: any) => {
      e.currentTarget?.requestFullscreen();
    });
  }
}
